import styled from 'styled-components';
import {
  space,
  width,
} from 'styled-system';

const Form = styled.form`
  ${space}
  ${width}
`;

export default Form;
